<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineExpose } from "vue";
    import { formatAmount } from '@/utils';
    import { computed, reactive, ref } from 'vue';

    let admin: any = null;
    const isOpened = ref(false);
    const errorMessage = ref('');
    const loading = ref(false);
    const itemInfos = reactive({
        nom: '',
        prenom: '',
        date_naissance: '',
        telephone: '',
        email: '',
        salaire: 0,
        quotite_cessible_montant: 0,
        quotite_cessible_pourcent: 0
    });
    const itemErrors = ref<any>({});
    
    async function open(dataRow: any) {
        console.log(dataRow);
        Object.assign(itemInfos, dataRow.data);
        itemErrors.value = dataRow.errors || {};
        isOpened.value = true;
    }

    function close() {
        isOpened.value = false;
    }

    const errorsText = computed(() => {
        return Object.values(itemErrors.value).flat().join(' ');
    });

    defineExpose({ open, close });
</script>

<template>
    <custom-modal v-model:show="isOpened">
        <template #header>
            <h4 class="font-semibold">Informations compte</h4>
        </template>
        <div>
            <div v-if="errorsText" class="alert alert-danger mb-4">{{ errorsText }}</div>
            <h5 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
                <img src="/icons/icon-info-perso.svg" class="size-base" alt="" />
                Informations personnelles
            </h5>
            <div class="item-row" :class="{ error: itemErrors.nom }">
                <div class="label">Nom</div>
                <div class="item-info">{{ itemInfos.nom || '-' }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.prenom }">
                <div class="label">Prénoms</div>
                <div class="item-info">{{ itemInfos.prenom || '-' }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.date_naissance }">
                <div class="label">Date naissance</div>
                <div class="item-info">{{ itemInfos.date_naissance || '-' }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.telephone }">
                <div class="label">Téléphone</div>
                <div class="item-info">{{ itemInfos.telephone || '-' }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.email }">
                <div class="label">Adresse Email</div>
                <div class="item-info">{{ itemInfos.email || '-' }}</div>
            </div>

            <h5 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
                <img src="/icons/icon-engagement.svg" class="size-base" alt="" />
                Engagement
            </h5>
            <div class="item-row" :class="{ error: itemErrors.salaire }">
                <div class="label">Salaire brut</div>
                <div class="item-info">{{ formatAmount(itemInfos.salaire) }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.quotite_cessible_montant || itemErrors.quotite_cessible_pourcent }">
                <div class="label">Quotité cessible</div>
                <div class="item-info">{{ formatAmount(itemInfos.quotite_cessible_montant) + ' (' + itemInfos.quotite_cessible_pourcent + '%)' }}</div>
            </div>
        </div>
        <template #footer>
            <button class="btn-ultra white2" style="justify-content: center;" @click="isOpened = false">Fermer</button>
        </template>
    </custom-modal>
</template>
